import Vue from 'vue';
import Vuex from 'vuex';
import stocks from '@/store/stocks';
import districts from '@/store/districts';
import stocksAutocompleteSearch from '@/store/stocksAutocompleteSearch';

export default () => {
  Vue.use(Vuex);

  return new Vuex.Store({
    state: {
    },
    modules: {
      stocks,
      districts,
      stocksAutocompleteSearch,
    },
  });
};
